// import adminNavigations from "./adminNavigations"

// export default [...adminNavigations]

import adminNavigation from './adminNavigation'
import SatocciNavigation from './SatoccieNavigation'

export default [...SatocciNavigation]
